// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zwIK","input":"styles_input__1b8TY"};